import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { H2, Section } from '../ui/Section';
import { CtaButton } from '../ui/CtaButton';
import { faqs } from '../../data/content';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <Section tone="white" narrow data-id="element-85" data-mp="usvvehqky50t">
      <H2 className="text-center" data-id="element-86" data-mp="70yh8jznr0wj">Frequently Asked Questions</H2>
      <div className="mt-10 divide-y divide-ink/10 border-y border-ink/10" data-id="element-87" data-mp="73aysw1i7992">
        {faqs.map((f, i) => {
        const isOpen = open === i;
        return <div key={f.q} data-id="element-88" data-mp="h05w5bm1j3lr" data-mpi={i}>
              <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-start justify-between gap-4 py-5 text-left" data-id="element-89" data-mp="gxbaxhv7dera">
                <span className="font-display text-lg font-bold leading-snug" data-id="element-90" data-mp="1ng9mw0bie8dj">
                  <span className="text-accent-strong" data-id="element-91" data-mp="htzdlxwnzlnm">{i + 1}.</span> {f.q}
                </span>
                <ChevronDownIcon className={`mt-1 h-5 w-5 shrink-0 text-accent-strong transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-92" data-mp="msk95k0z1h5q" />
              </button>
              <AnimatePresence initial={false} data-id="element-93" data-mp="vspd1k6yhxf5">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-94" data-mp="3v9x1nd9xehir">
                    <div className="space-y-2 pb-5 text-base leading-relaxed text-ink/75" data-id="element-95" data-mp="3ci491jyrqybk">
                      {f.a.map(p => <p key={p} data-id="element-96" data-mp="3giy20rr2j3bb">{p}</p>)}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>

      <div className="mt-10" data-id="element-97" data-mp="ipcyeksvq2hy">
        <CtaButton label="Get my complete implant clinical roadmap™" note="$27 USD · 7-Day Guarantee" data-id="element-98" data-mp="iobpomzc5s3e" />
      </div>
    </Section>;
}